
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import DatePicker from '@/components/searchPage/DatePicker.vue';
import StateSelect from '@/components/searchPage/components/StateSelect/StateSelect.vue';
import ToggleButton from '@/components/UI/ToggleButton.vue';
import LookupCustomerCode from '@/components/jobBooking/AdvancedJobBooking/LookupCustomerCode.vue';
import { AirRoadBookingStateData, AirRoadFiltersCheckboxes } from '@/models/airRoad';

@Component({
  components: { LookupCustomerCode, ToggleButton, StateSelect, DatePicker },
})
export default class AirRoadFilters extends Vue {
  @Prop(Array) dates!: Array<string>;
  @Prop(Boolean) loading!: boolean;
  @Prop(String) customerCode!: string;
  @Prop(Function) autocompleteCustomer: (item: Promise<string[]>) => void;
  @Prop(Array) selectedStates!: Array<string>;
  @Prop(Object) checkboxes!: Record<string, boolean>;
  @Prop(Object) bookingState!: AirRoadBookingStateData;

  public filterDates: string[] = [];
  public filterCustomerCode = '';
  public filterSelectedStates: string[] = [];
  public filterSearchValue = '';
  public filterCheckboxes: AirRoadFiltersCheckboxes = {
    only920Driver: true,
    exclude920Driver: false,
    fromWarehouse: false,
    toWarehouse: false,
  };

  @Watch('dates', { immediate: true })
  onDatesChanged(newVal: string[]) {
    this.filterDates = newVal;
  }

  @Watch('customerCode', { immediate: true })
  onCustomerCodeChanged(newVal: string) {
    this.filterCustomerCode = newVal;
  }

  @Watch('selectedStates', { immediate: true })
  onSelectedStatesChanged(newVal: string[]) {
    this.filterSelectedStates = newVal;
  }

  @Watch('checkboxes', { immediate: true, deep: true })
  onCheckboxesChanged(newVal: AirRoadFiltersCheckboxes) {
    this.filterCheckboxes = { ...newVal };
  }

  submitFilters() {
    if (this.filterCheckboxes.only920Driver) {
      this.filterCheckboxes.exclude920Driver = false;
    }
    if (this.filterCheckboxes.exclude920Driver) {
      this.filterCheckboxes.only920Driver = false;
    }

    this.$emit('submit', {
      dates: this.filterDates,
      customerCode: this.filterCustomerCode,
      selectedStates: this.filterSelectedStates,
      searchValue: this.filterSearchValue,
      checkboxes: this.filterCheckboxes,
    });
  }
}
